import { Link } from "wouter";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-4">
          Страница не найдена
        </h2>
        <p className="text-muted-foreground mb-8">
          Извините, запрашиваемая страница не существует.
        </p>
        <Link href="/">
          <button className="btn-primary">
            Вернуться на главную
          </button>
        </Link>
      </div>
    </div>
  );
}
